var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-detail app-main-content" },
    [
      _c(
        "el-card",
        { staticClass: "toolbar-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-button",
            { attrs: { icon: "el-icon-back" }, on: { click: _vm.goBack } },
            [_vm._v("返回")]
          )
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c("cargo-ag-grid", {
            ref: "agGrid",
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": _vm.provisionConfigModule,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.finalColumnDefs,
              "row-data": _vm.rowData,
              "filter-menu-items": _vm.filterMenuItems
            },
            on: { gridReady: _vm.onGridReady }
          }),
          _c("cargo-pagination", {
            staticClass: "pagination",
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: _vm.getList
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }